// Routing rules: one default per category, plus optional per-condo overrides.
// Both lists are plain arrays. The resolver's answer is the backend's and is
// never cached: the page asks again whenever its inputs change.
import {
  listDefaults,
  createDefault,
  updateDefault,
  deleteDefault,
  listOverrides,
  createOverride,
  updateOverride,
  deleteOverride,
  resolveRouting,
} from '../../api/coLiving/routing';

export const state = {
  defaults: [],
  overrides: [],
  uiFlags: { isFetching: false },
};

export const getters = {
  getDefaults: s => s.defaults,
  getOverrides: s => s.overrides,
  getUiFlags: s => s.uiFlags,
};

export const mutations = {
  setDefaults(s, defaults) {
    s.defaults = defaults;
  },
  setOverrides(s, overrides) {
    s.overrides = overrides;
  },
  setUiFlag(s, { key, value }) {
    s.uiFlags = { ...s.uiFlags, [key]: value };
  },
};

export const actions = {
  async fetchRules({ commit }) {
    commit('setUiFlag', { key: 'isFetching', value: true });
    try {
      const [defaults, overrides] = await Promise.all([
        listDefaults(),
        listOverrides(),
      ]);
      commit('setDefaults', defaults.data);
      commit('setOverrides', overrides.data);
    } finally {
      commit('setUiFlag', { key: 'isFetching', value: false });
    }
  },
  async addDefault({ dispatch }, fields) {
    const { data } = await createDefault(fields);
    await dispatch('fetchRules');
    return data;
  },
  async editDefault({ dispatch }, { id, fields }) {
    const { data } = await updateDefault(id, fields);
    await dispatch('fetchRules');
    return data;
  },
  async removeDefault({ dispatch }, id) {
    await deleteDefault(id);
    await dispatch('fetchRules');
  },
  async addOverride({ dispatch }, fields) {
    const { data } = await createOverride(fields);
    await dispatch('fetchRules');
    return data;
  },
  async editOverride({ dispatch }, { id, fields }) {
    const { data } = await updateOverride(id, fields);
    await dispatch('fetchRules');
    return data;
  },
  async removeOverride({ dispatch }, id) {
    await deleteOverride(id);
    await dispatch('fetchRules');
  },
  async resolve(_, params) {
    const { data } = await resolveRouting(params);
    return data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
